import { Component } from '@angular/core'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'

interface GuardianToInvite {
  email: string
  access: string
}

const exampleHtml = `
<se-po-guardian-invite-info
  [guardianToInvite]="guardianToInvite"
  (cancelInvite)="onCancelInvite($event)">
</se-po-guardian-invite-info>
`

const exampleTypescript = `
import { Component, OnInit } from '@angular/core'

interface GuardianToInvite {
  email: string;
  access: string;
}

export class GuardianInviteInfoExampleComponent implements OnInit {
  public guardianToInvite: GuardianToInvite

  public ngOnInit(): void {
    this.guardianToInvite = {
      email: 'b.fisher@gmail.com', access: 'manager'
    }
  }
}
`

const template = `<se-fe-docs-example [example]="this">${ exampleHtml }</se-fe-docs-example>`

@Component({
  selector: 'se-po-guardian-invite-info-example',
  template,
  styleUrls: ['./guardian-invite-info-docs.component.scss'],
  standalone: false,
})
export class GuardianInviteInfoExampleComponent extends SeFeDocsExampleComponent {
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]

  public guardianToInvite =  {
    email: 'b.fisher@gmail.com', access: 'manager'
  }


  public onCancelInvite(email: string): void {
    console.log(email)
  }

}
